import type { ComponentType } from "react";

import LabeledField from "./LabeledField";

interface InjectLabelProps {
  value: boolean;
  greenEmojiIfNegative?: boolean;
}

export function InjectLabel({
  value,
  greenEmojiIfNegative = false,
}: InjectLabelProps) {
  return (
    <span className="font-light text-sm">
      {greenEmojiIfNegative ? (value ? "🟡 " : "🟢 ") : value ? "🟢 " : "🟡 "}
    </span>
  );
}

interface BooleanFieldProps {
  label: string;
  value: boolean;
  yesText?: string;
  noText?: string;
  InjectLabelComponent?: ComponentType<InjectLabelProps>;
  InjectCicleEmojiIfPositive?: boolean;
  InjectCicleEmojiIfNegative?: boolean;
  InjectCicleEmoji?: boolean;
  hintText?: string;
  iconClassName?: string;
  tooltipClassName?: string;
  className?: string;
  labelClassName?: string;
  greenEmojiIfNegative?: boolean;
}

function BooleanField({
  label,
  value,
  yesText = "Есть",
  noText = "Отсутствует",
  InjectLabelComponent = InjectLabel,
  InjectCicleEmojiIfPositive = true,
  InjectCicleEmojiIfNegative = true,
  InjectCicleEmoji = true,
  hintText = "",
  iconClassName = "",
  tooltipClassName = "",
  className = "",
  labelClassName = "",
  greenEmojiIfNegative = false,
}: BooleanFieldProps) {
  let toInjectLabelComponent = false;
  if (InjectLabelComponent && InjectCicleEmoji) {
    if (InjectCicleEmojiIfPositive === true && value) {
      toInjectLabelComponent = true;
    }
    if (InjectCicleEmojiIfPositive === false && !value) {
      toInjectLabelComponent = true;
    }
    if (InjectCicleEmojiIfNegative === true && !value) {
      toInjectLabelComponent = true;
    }
    if (InjectCicleEmojiIfNegative === false && value) {
      toInjectLabelComponent = true;
    }
  }

  return (
    <LabeledField
      label={label}
      hintText={hintText}
      tooltipClassName={tooltipClassName}
      iconClassName={iconClassName}
      labelClassName={labelClassName}
      className={className}
    >
      {toInjectLabelComponent && (
        <InjectLabelComponent
          value={value}
          greenEmojiIfNegative={greenEmojiIfNegative}
        />
      )}
      {value ? yesText : noText}
    </LabeledField>
  );
}

export default BooleanField;
